<!-- Default slot expects content to be wrapped in a grid content element -->
<template>
    <div class="ls-panel" :class="{ 'ls-padding--bottom-none': !hideDivider && !$slots.button }">
        <div v-if="$slots.header" class="ls-panel__header">
            <slot name="header"></slot>
        </div>

        <div>
            <slot></slot>
        </div>

        <div v-if="$slots.button" class="ls-panel__button-container">
            <slot name="button"></slot>
        </div>

        <div v-if="!hideDivider && !$slots.button" class="grid">
            <div class="grid__col-12 ls-panel__bottom-divider">
                <hr />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        hideDivider: {
            type: Boolean,
        },
    },
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
.ls-panel {
    padding-bottom: rem(0);
    background-color: palette(white);
    @include max-screen(breakpoint(xs, max)) {
        padding: rem(0) 0;
    }
    @include min-screen(breakpoint(sm)) {
        padding: rem(0) rem(-3); // smaller padding horizontal to compensate for padding on `.grid__col-*` elements
    }
}

.ls-panel__header {
    border-bottom: 1px solid palette(gray, x-light);
}

.ls-panel__bottom-divider {
    hr {
        margin-top: rem(3);
        margin-bottom: 0;
        border-color: palette(gray, x-light);
    }
}
.themed-app {
    .ls-panel {
        background-color: $theme-color-white;
    }

    .ls-panel__header {
        border-color: $theme-color-gray;
    }

    .ls-panel__bottom-divider {
        hr {
            border-color: $theme-color-gray;
        }
    }
}
</style>
